module.exports = __webpack_public_path__ + "0f15b731eec3fc7b4c45006a4d61419a.pdf";